import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
function totalOf(totals, key) {
  if (totals instanceof Map) return { has: totals.has(key), value: totals.get(key) };
  const record = totals;
  return { has: Object.prototype.hasOwnProperty.call(record, key), value: record[key] };
}
const TableFooterRow = React.forwardRef(function TableFooterRow2({ columns, totals, label, labelColumn, labelAs = "th", leadingCells = 0, stickyFirstColumn, cellClassName, className, ...rest }, ref) {
  const labelKey = labelColumn ?? columns[0]?.key;
  const lead = Array.from({ length: leadingCells }, (_, i) => /* @__PURE__ */ jsx("td", { className: cx("ev-table-foot__cell", cellClassName, stickyFirstColumn && i === 0 && "ev-sticky-col") }, `lead-${i}`));
  return /* @__PURE__ */ jsxs("tr", { ref, ...rest, className: cx("ev-table-foot__row", className), children: [
    lead,
    columns.map((column, i) => {
      const sticky = stickyFirstColumn && leadingCells === 0 && i === 0;
      const numeric = column.align === "numeric" || column.align === "end";
      const { has, value } = totalOf(totals, column.key);
      const cls = cx("ev-table-foot__cell", numeric && "ev-num", sticky && "ev-sticky-col", column.className, cellClassName);
      if (!has && column.key === labelKey) {
        return labelAs === "th" ? /* @__PURE__ */ jsx("th", { scope: "row", className: cx(cls, "ev-table-foot__label"), children: label }, column.key) : /* @__PURE__ */ jsx("td", { className: cx(cls, "ev-table-foot__label"), children: label }, column.key);
      }
      return /* @__PURE__ */ jsx("td", { className: cls, "data-total": has ? column.key : void 0, children: has ? value : null }, column.key);
    })
  ] });
});
TableFooterRow.displayName = "TableFooterRow";
const TableFooter = React.forwardRef(function TableFooter2({ sticky = true, className, ...rest }, ref) {
  return /* @__PURE__ */ jsx("tfoot", { ref, ...rest, className: cx("ev-table-foot", className), "data-sticky": sticky ? "true" : void 0 });
});
TableFooter.displayName = "TableFooter";
const TableFooterTotals = React.forwardRef(function TableFooterTotals2({ className, rowClassName, sticky, ...row }, ref) {
  return /* @__PURE__ */ jsx(TableFooter, { ref, className, ...sticky !== void 0 ? { sticky } : {}, children: /* @__PURE__ */ jsx(TableFooterRow, { ...row, className: rowClassName }) });
});
TableFooterTotals.displayName = "TableFooterTotals";
export {
  TableFooter,
  TableFooterRow,
  TableFooterTotals
};
//# sourceMappingURL=TableFooterTotals.js.map
